module.exports = __webpack_public_path__ + "img/Logo_scienotransparent.717f01b9.png";